// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { GroundTruthRunKind } from "./GroundTruthRunKind.gen";
import { GroundTruthJobStatus } from "./GroundTruthJobStatus.gen";
import { GroundTruthCounter } from "./GroundTruthCounter.gen";

export interface IGroundTruthRunSummary {
	id: string | undefined;

	kind: GroundTruthRunKind;

	status: GroundTruthJobStatus;

	facilityId: string | undefined;

	facilityName: string | undefined;

	requestedById: string | undefined;

	requestedBy: string | undefined;

	clientIp: string | undefined;

	requestDate: string | undefined;

	asOfDate: string | undefined;

	completedDate: string | undefined;

	photoCount: number;

	totalBytes: number | undefined;

	totalCount: number | undefined;

	classCountsJson: string | undefined;

	counter: GroundTruthCounter;

	counterModel: string | undefined;

	stitchMs: number | undefined;

	inferenceMs: number | undefined;

	errorMessage: string | undefined;

	responseJson: string | undefined;

	responseStatusCode: number | undefined;

	$type?: string | undefined;
}
export class GroundTruthRunSummary {
	constructor(data?: IGroundTruthRunSummary) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.requestDate) { this.requestDate = new Date(data.requestDate); }
		if (data.asOfDate) { this.asOfDate = new Date(data.asOfDate); }
		if (data.completedDate) { this.completedDate = new Date(data.completedDate); }
	}

	id: string | undefined;

	kind: GroundTruthRunKind = 0;

	status: GroundTruthJobStatus = 0;

	facilityId: string | undefined;

	facilityName: string | undefined;

	requestedById: string | undefined;

	requestedBy: string | undefined;

	clientIp: string | undefined;

	requestDate: Date | undefined = new Date();

	asOfDate: Date | undefined;

	completedDate: Date | undefined;

	photoCount: number = 0;

	totalBytes: number | undefined;

	totalCount: number | undefined;

	classCountsJson: string | undefined;

	counter: GroundTruthCounter = 0;

	counterModel: string | undefined;

	stitchMs: number | undefined;

	inferenceMs: number | undefined;

	errorMessage: string | undefined;

	responseJson: string | undefined;

	responseStatusCode: number | undefined;

	static $type: string = "CoreApi.Models.GroundTruthRunSummary, ";
	$type?: string | undefined = GroundTruthRunSummary.$type;
}

